import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import isEmpty from "lodash/isEmpty"
import sortBy from "lodash/sortBy"
import find from "lodash/find"
import { TrashIcon } from "@infotech/uikit-icons"
import { selectCurrentList } from "src/engine/modules/lists/selectors"
import { readList } from "src/engine/modules/lists/actions/creators/read"
import { removeList } from "src/engine/modules/lists/actions/creators/remove"
import { LIST_NAME, getBasicUrl } from "./helper/constants"
import styles from "./styles.css"

const EventTypeList = props => {
  const {
    planTypeId,
    readList,
    removeList,
    planTypeTemplates,
    isLoading,
    isVirtual,
    templates,
    isDisabled,
  } = props
  useEffect(() => {
    if (!isEmpty(templates) && planTypeId) {
      readList({
        basicUrl: getBasicUrl(planTypeId),
        name: LIST_NAME,
        outerData: templates,
      })
    }
  }, [planTypeId, templates])

  const templatesData =
    (planTypeTemplates &&
      !planTypeTemplates.reading &&
      !isEmpty(planTypeTemplates.data) &&
      sortBy(
        planTypeTemplates.data
          .map(item =>
            find(planTypeTemplates.outerData, outer => outer.code === item),
          )
          .filter(Boolean),
        item => item.name,
      )) ||
    []
  return (
    <>
      {!isVirtual &&
        !isLoading &&
        planTypeTemplates &&
        !isEmpty(planTypeTemplates.data) && (
          <Box loose className={styles.TemplatesWrapper}>
            {templatesData.map(item => (
              <Box
                loose
                className={styles.CurrentTemplates}
                flex
                pl="2md"
                pt="1md"
                pb="1md"
              >
                <Box loose>
                  <Box
                    pt="4px"
                    loose
                    className={cn(
                      styles.SelectDropdownOptionLabel,
                      styles.CurrentTemplatesLabel,
                    )}
                  >
                    {item.name}
                  </Box>
                </Box>
                {isDisabled ? null : (
                  <Box
                    loose
                    className={styles.RightIconWrapper}
                    onClick={() =>
                      removeList({
                        basicUrl: getBasicUrl(planTypeId),
                        name: LIST_NAME,
                        id: item.code,
                      })
                    }
                  >
                    <TrashIcon color="#808080" />
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        )}
    </>
  )
}

EventTypeList.propTypes = {
  planTypeId: PropTypes.oneOf([`string`, `number`]).isRequired,
  readList: PropTypes.func.isRequired,
  removeList: PropTypes.func.isRequired,
  planTypeTemplates: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isVirtual: PropTypes.bool.isRequired,
  templates: PropTypes.shape({
    status: PropTypes.string,
    data: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default compose(
  connect(
    state => ({
      planTypeTemplates: selectCurrentList(state, LIST_NAME),
    }),
    {
      readList,
      removeList,
    },
  ),
)(EventTypeList)
